import React, { useContext, useEffect, useState } from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import "./ProductDetail.scss";

import { FaFacebookF } from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";

import photoProduct from "../../assets/img/products/product.jpg";
import ProductosHeader from "../Tienda/views/Producto/ProductoHeader";
import ProductoImages from "../Tienda/views/Producto/ProductoImages";

import imagenNoDisponible from "../../assets/image_not_found.png";
import CantidadSelectorController from "../Tienda/components/CantidadSelector/CantidadSelectorController";
import functions from "../Tienda/functions/functions";
import { CartContext } from "../Tienda/components/ParadigmaCartProvider/ParadigmaCartProvider";
import { useHistory } from "react-router-dom";
import { DescripcionPreciosModal } from "../DescripcionPreciosModal/DescripcionPreciosModal";
import { ClickInLogin } from "../Tienda/components/CheckoutButton/CheckoutButtonUtils";
import { LoginContext } from "../Tienda/components/ParadigmaLoginProvider/ParadigmaLoginProvider";
import { GlobalConfigTienda } from "../TiendaConfig";
import Related from "../Tienda/views/Producto/Related";

const Compartir = ({ titulo }) => (
  <div className="col-12 mt-2 bg-light">
    <p className="font-italic p-2 mb-0 text-right">
      Compartilo{" "}
      <a
        className="mr-2 cFacebook"
        href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fbahiaconstrucciones.com.ar"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaFacebookF />
      </a>
      <a
        className="mr-2 cWhatsapp mr-3"
        href={`whatsapp://send?text=Hola, mira esto: ${titulo}`}
        data-action="share/whatsapp/share"
        target="_blank"
        rel="noopener noreferrer"
      >
        <BsWhatsapp />
      </a>
    </p>
  </div>
);

const ProductDetail = (props) => {
  const { loading, breadcrumbs, producto } = props;
  const cartItem = producto
    ? { code: producto.code, talle_id: null, color_id: null }
    : null;
  const cartContext = useContext(CartContext);
  const enCarrito = cartContext.getCantidadItem({ ...cartItem });
  const stockDisponible = cartItem
    ? functions.getMaxQuantity(producto, null, null)
    : 0;
  const [cantidad, setCantidad] = useState(enCarrito);
  const [showOptions, setShowOptions] = useState(false);

  const logged = useContext(LoginContext).logged;

  useEffect(() => {
    setCantidad(enCarrito);
  }, [enCarrito]);

  const history = useHistory();

  const goCard = () => {
    cartContext.setItem({ ...cartItem, quantity: cantidad });
    let path = `/tienda/checkout`;
    history.push(path);
  };

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };

  // Ver description (colapsable) del producto en mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showContent, setShowContent] = useState(!isMobile);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setShowContent(!mobile);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleContent = () => {
    setShowContent(!showContent);
  };



  return (
    !!producto && (
      <>
        <div className="esige-producto">
          <ProductosHeader loading={loading} breadcrumbs={breadcrumbs} />
          <div className="container esige-producto-container mb-5">
            <div className="row">
              <Compartir titulo={producto.Titulo} />
            </div>

            <div className="row">
              <div className="col-12 col-lg-7 esige-producto-main-detail">
                <div className="row flex-md-row-reverse nowrap">
            
                  {/* <div className="col-md-7 order-md-2"></div> */}
                  <ProductoImages
                    magnifier={true}
                    images={
                      loading || !!!producto
                        ? [
                            {
                              src: imagenNoDisponible,
                              talle_id: null,
                              color_id: null,
                            },
                          ]
                        : producto.Imagenes
                    }
                    cartItem={cartItem}
                  />
                  
                </div>
              </div>

              <div className="col-12 col-lg-5">
                <div className="px-5 py-4 py-md-2">
                  <div className="bg-title">
                    <h3>{producto.Titulo}</h3>
                  </div>
                  {/* <p className="product__price">${new Intl.NumberFormat('es-ES')
                    .format(  Math.round(producto.Precio) ) }</p> */}
                  {/* {!sinPrecio ? ( */}
                  {!false ? (
                    producto.PrecioSuperOferta !== 0 ? (
                      <>
                        <p className="product__price">
                          $
                          {functions.FormatPrice(
                            producto.PrecioSuperOferta,
                            GlobalConfigTienda.NumeroDecimales
                          )}
                        </p>
                        <del className="priceOld -mt-n1 mb-4">
                          $
                          {functions.FormatPrice(
                            producto.Precio,
                            GlobalConfigTienda.NumeroDecimales
                          )}
                        </del>
                      </>
                    ) : (
                      <p className="product__price">
                        $
                        {functions.FormatPrice(
                          producto.Precio,
                          GlobalConfigTienda.NumeroDecimales
                        )}
                      </p>
                    )
                  ) : (
                    <p className="product__price">Consultar</p>
                  )}

                  {/* <p className="text-center">
                    <small>
                      Precio de lista $
                      {new Intl.NumberFormat("es-ES").format(
                        (producto.PrecioLista * 1.3).toFixed(0)
                      )}
                    </small>
                  </p> */}

                  <p className="mt-2 mb-1 mt-md-5 mb-md-2 text-center">Medios de pago:</p>
                  <DescripcionPreciosModal 
                    PrecioBase={(producto.PrecioSuperOferta > 0) ? producto.PrecioSuperOferta : producto.Precio}
                  />

                  <div className="row my-4 d-flex align-items-center text-center">
                    <div className="col-12 col-md-5">Cantidad:</div>
                    <div className="col-12 col-md-7">
                      <CantidadSelectorController
                        className="ml-2 m-0 justify-content-center"
                        cantidadDisponible={stockDisponible}
                        cantidad={cantidad}
                        onChange={(cantidad) => setCantidad(cantidad)}
                      />
                    </div>
                  </div>
                  <button
                    className="btn btn-success btn-lg w-100"
                    disabled={!producto.IgnorarStock && stockDisponible <= 0}
                    // onClick={() => cartContext.setItem({ ...cartItem, quantity: cantidad, })}
                    // onClick={goCard}
                    onClick={() => (logged ? goCard() : ClickInLogin())}
                  >
                    Comprar ahora &gt;
                  </button>

                  <button
                    className="btn btn-primary btn-lg w-100 mt-3"
                    onClick={toggleOptions}
                  >
                    Contactar con un vendedor
                  </button>

                  {showOptions && (
                    <div className="mt-3">
                      <button
                        className="btn btn-outline-dark w-100 mb-2"
                        onClick={() => window.location.href = 'https://web.whatsapp.com/send/?phone=542916435709'}
                      >
                        Peatonal Drago 72
                      </button>
                      <button
                        className="btn btn-outline-dark w-100"
                        onClick={() => window.location.href = 'https://web.whatsapp.com/send/?phone=2914629352'}
                      >
                        Chiclana 130
                      </button>
                    </div>
                  )}
                  

                  <button
                    className="btn btn-success btn-success__light btn-lg mt-3 w-100"
                    disabled={!producto.IgnorarStock && stockDisponible <= 0}
                    onClick={() =>
                      cartContext.setItem({
                        ...cartItem,
                        quantity: cantidad,
                      })
                    }
                  >
                    Agregar al carrito &gt;
                  </button>

                  <div className="product__detail p-0 pt-4 pt-md-0 py-md-5">
                      { 
                        // **************************************************
                        // Mostrar/Ocultar contenido de descripcion en mobile 
                        // **************************************************
                      }
                      <div>
                        {isMobile && (
                          <a className="btn btn-outline-secondary mb-3" onClick={toggleContent}>
                            {showContent ? 'Ocultar Descripción' : 'Mostrar Descripción'}
                          </a>
                        )}
                        {showContent && (
                          <>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: producto.Descripcion,
                              }}
                            ></div>
                            {
                              (producto.Info !== '<p>(Sin Información)</p>') && (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: producto.Info,
                                  }}
                                ></div>
                              )
                            }
                          </>
                        )}
                      </div>
                     
                    </div>



                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Related producto={producto} />
              </div>
            </div>

          </div>
        </div>
      </>
    )
  );
};

export default ProductDetail;
